import { useIsDarkTheme } from '../nutrition/nutritionPalette';

/**
 * ⭐ Supplements' own colour (owner, 2026-10-22): AMETHYST — the tray's light, the pills taken,
 * the one solid "Taken" button for the next dose. Like Hydration's cyan and Nutrition's saffron,
 * it is for content only; Personal's red stays on the signposts (the lens pill, Stats | Actions,
 * the section underline, the header icon). Chosen clear of red, cyan, saffron, the green "taken"
 * check and the amber warnings.
 *
 * Light twin: #6D4FC2 (5.9:1 on white, so text and marks both read) with white ink; on the
 * dark card the pale amethyst takes a dark ink.
 */
export const SUPPLEMENTS_PALETTE = {
  dark: { accent: '#B49BFF', ink: '#1A1033' },
  light: { accent: '#6D4FC2', ink: '#FFFFFF' },
} as const;

/** Supplements' accent and its ink for the current theme. */
export function useSupplementsPalette(): { accent: string; ink: string } {
  return useIsDarkTheme() ? SUPPLEMENTS_PALETTE.dark : SUPPLEMENTS_PALETTE.light;
}
